import { ReactNode, useState } from "react";
import { ProductFeature } from "../../../api/featureRequests";
import FeatureAutocomplete, { FeatureChoice } from "./FeatureAutocomplete";
import DSDialog from "../../system-design/DSDialog";
import DSDialogTitle from "../../system-design/DSDialogTitle";
import DSDialogContent from "../../system-design/DSDialogContent";
import DSDialogActions from "../../system-design/DSDialogActions";
import DSPrimaryButton from "../../system-design/DSPrimaryButton";
import DSSecondaryButton from "../../system-design/DSSecondaryButton";
import DSAlert from "../../system-design/DSAlert";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";

// Picks another existing feature — used to merge a feature or move a request.
const PickFeatureDialog = (props: {
  open: boolean;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  features: ProductFeature[];
  excludeId: string;
  isPending: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: (feature: ProductFeature) => void;
}) => {
  const [choice, setChoice] = useState<FeatureChoice | null>(null);

  return (
    <DSDialog
      open={props.open}
      onClose={props.onClose}
      fullWidth
      maxWidth="sm"
      TransitionProps={{ onEnter: () => setChoice(null) }}
    >
      <DSDialogTitle>{props.title}</DSDialogTitle>
      <DSDialogContent>
        <DSBox sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          <DSTypography>{props.description}</DSTypography>
          <FeatureAutocomplete
            features={props.features}
            value={choice}
            onChange={setChoice}
            excludeId={props.excludeId}
            autoFocus
          />
          {props.error && <DSAlert severity="error">{props.error}</DSAlert>}
        </DSBox>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={props.onClose}>Cancel</DSSecondaryButton>
        <DSPrimaryButton
          disabled={choice?.kind !== "existing" || props.isPending}
          onClick={() =>
            choice?.kind === "existing" && props.onConfirm(choice.feature)
          }
        >
          {props.confirmLabel}
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default PickFeatureDialog;
